import React from "react";
import styled from "styled-components";
import { getHeading6RegularTypography } from "../../../Typography";
import { useTranslation } from "react-i18next";
import { getParagraph16RegularTypography } from "../../../Typography/Paragraph16";

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

const BidEth = styled.h4`
  ${getHeading6RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  line-height: 23px;
`;

const BidLabel = styled.p`
  ${getParagraph16RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  opacity: 0.7;
`;

const BidFiat = styled.h4`
  ${getHeading6RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  line-height: 23px;
`;

type Props = {
  priceUsd: string;
  formattedPrice: string;
};

const InstantBidPanel = ({ formattedPrice, priceUsd }: Props) => {
  const { t } = useTranslation();

  return (
    <Root>
      <Container>
        <BidLabel>{t("instant-purchase-price")}</BidLabel>
        <Details>
          <BidEth>{formattedPrice}</BidEth>
          <BidFiat>${priceUsd}</BidFiat>
        </Details>
      </Container>
    </Root>
  );
};

export default InstantBidPanel;
